<p> Prof Andrew YT Leung has participated in a number of projects: </p>
<div class="container">
  <div class="row">
    <div *ngFor='let type of typeList' class="md-col-2">
      <button
        type="button"
        class='typeButton btn btn-outline-primary'
        (click)="onSelectProjectType(type)"
        #projectType>
        {{ type }}
      </button>
    </div>
  </div>
</div>


<p id='past-project-table-title'> {{ typeFilter }} </p>

<table *ngIf='typeFilter' class='table'>
  <tr>
    <th>Year</th>
    <th>Project</th>

  </tr>
  <ng-container *ngFor="let project of project$ | async">
    <tr *ngIf='project.type == typeFilter'>
      <td> {{ project.year }} </td>
      <td> {{ project.project }} </td>
    </tr>
  </ng-container>

</table>
<button
  *ngIf='typeFilter'
  type="button"
  class='typeButton btn btn-outline-secondary'
  (click)="onSelectProjectType('')"
  #projectType>
  Close
</button>
